export default __webpack_public_path__ + "static/media/owlogo-small.787f124f.webp";